module.exports = __webpack_public_path__ + "img/c8.23c6c134.png";